import { Header, PostItem, Text } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { queryKeys, routes, TEXT_STRING } from '../../../constants';
import { getPost } from 'api';
import NotFound from 'pages/NotFound';

function Status() {
  const { postId } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.DETAIL_POST, postId],
    queryFn: async () => {
      return getPost(+postId!);
    },
    staleTime: Infinity,
    retry: false,
    enabled: !!postId,
  });

  if (!data && !isLoading) {
    return <NotFound />;
  } else {
    return (
      <div>
        <Header
          title={<NavigateBackLabel />}
          onBack={() => navigate(routes.HOME)}
        />
        {data && <PostItem className="p-4" data={data} showThumbnail={false} />}
      </div>
    );
  }
}

export default Status;

const NavigateBackLabel = () => {
  return (
    <Text fontSize={18} bold className="absolute left-20 -mt-1">
      {TEXT_STRING.POST.POST_STATUS_LABEL}
    </Text>
  );
};
